<template>
  <v-select
    id="axis-select"
    v-model ="filter.grupo"
    item-text ="nome"
    item-name ="grupoId"
    :items="groups.grupos"
    :label ="name"
    placeholder ="Grupo"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
    :return-object=true
  >
    <template slot="no-data">
      Nenhum Grupo retornado
    </template>
  </v-select>
</template>

<script>
import { groupAPI } from '../GroupAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppGroupSolutionCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false },
    name: {type: String, default: 'Grupo'}
  },
  mounted () {
    this.loadGroups()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadGroups () {
      this.setLoading(true)
      groupAPI.getWithSolution(this.filter.municipioId)
        .then(resp => {
          this.groups = resp.data
          this.setLoading(false)
        })
        .catch(this.setLoading(false))
    }
  },
  data () {
    return {
      groups: []
    }
  }
}
</script>
